let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lUDpe")).then(() => parcelRequire('9loVs'));